export const PATH = {
  START_PAGE: '/',
  LOGIN: '/login',
  REGISTRATION: '/registration',
  PROFILE: '/profile',
  FORGOT_PASS: '/forgot-password',
  NEW_PASS: '/new-password/:resetToken',
  PAGE404: '/404',
  WRONG_PATH: '*',
  PACKS: '/packs',
  PACK: '/packs/:id_pack',
  CARD: '/packs/pack/:id_pack/card/:id_card',
  ADD_NEW_PACK: '/add-new-pack',
  LEARN: '/packs/pack/:id_pack/learn',
}
